import { CartContext } from '../../../features/cartContext/CartContext'
import { useContext, useState } from 'react'
import ShoppingCart from './ShoppingCart';
import { useEffect } from 'react'
import { Link } from 'react-router-dom';

const NewOrder = () => {
    const [shippingPrice, setShippingPrice] = useState(0)
    const [discount, setDiscount] = useState(0)
    const [subTotalVal, setSubTotalVal] = useState(0)
    const [taxEstimation, setTaxEstimation] = useState(0)
    const [totalPriceVal, setTotalPriceVal] = useState(0)
    const [tipping, setTipping] = useState(0)
    const [openTipsLink, setOpenTipsLink] = useState(true);
    const [customTip, setCustomTip] = useState(true);
    const [deliveryTypeVal, setDeliveryTypeVal] = useState("regular")
    const [foodOrderType, setFoodOrderType] = useState(false)
    const [groceryOrderType, setGrceryOrderType] = useState(false)
    const cart = useContext(CartContext)

    useEffect(() => {
        cart.items.map((val) => {
            if (val.product.fType.toLowerCase() === "spices".toLowerCase() || val.product.fType.toLowerCase() === "liquour".toLowerCase() || (val.product.fType).toLowerCase() === "grocery".toLowerCase() || val.product.fType.toLowerCase() === "cloth".toLowerCase() || val.product.fType.toLowerCase() === "others".toLowerCase()) {
                setGrceryOrderType(true)
            }
            if (val.product.fType.toLowerCase() === "Breakfast".toLowerCase() || val.product.fType === "Lunch".toLowerCase() || val.product.fType.toLowerCase() === "Dinner".toLowerCase() || val.product.fType.toLowerCase() === "lunch&Dinner".toLowerCase() || val.product.fType.toLowerCase() === "vegetarian".toLowerCase() || val.product.fType.toLowerCase() === "vegan".toLowerCase()) {
                setFoodOrderType(true)
            }
        })
    }, [cart]);

    let tableContent_mod

    let EmptyCart = (

        <div className="container px-4 sm:px-8 mx-auto max-w-xl">
            <div className="wrapper bg-white rounded-sm shadow-xs">

                <div className="card px-8 py-4">

                    <span className="inline-block align-middle">
                        <div className=' inline-flex align-middle text-center gap-4 my-6'>
                            <svg
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-10 h-10 text-red-400 text-center ">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                            </svg>

                            <h1 className="text-xl md:text-2xl font-bold leading-tight text-center text-gray-900">Your Cart is Empty!</h1>

                        </div>
                    </span>

                    <div className="card-text">
                        <p className="text-base  md:text-lg text-gray-700 mt-3 ">Add products while you shop, so they'll be ready for checkout later.!</p>
                    </div>

                    <div className="card-mail flex items-center my-10">
                        <button className="bg-gray-200 hover:bg-gray-600/20  text-black/60 font-bold capitalize px-3 py-2 text-base md:text-lg rounded-lg border-l border-t border-r border-b border-orange-500">
                            <Link to={"/Shop"}>
                                Countinue Shopping
                            </Link>
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )

    let tableContent_mod_ = cart.items.map((currentData, idx) => (
        <ShoppingCart key={idx} {...currentData} />
    ))

    const onfTypeChanged = e => setShippingPrice(e.target.value)
    const onDiscountChanged = e => {
        setDiscount(parseFloat(e.target.value))
        setDiscount(0);
    }

    const shippingOptions = [4.99, 6.99, 12.99, 20.00].map((val, ind) => {
        return (
            <option
                key={ind}
                value={val}
            > {val}</option >
        )
    })

    const array = [{ regular: 15 }, { twodaysdelivery: 16 }, { threedaysdelivery: 17 }, { onedaydelivery: 18 }];

    function reducer(accumulator, currentValue, index) {
        const returns = accumulator + currentValue;
        return returns;
    }

    // array.reduce(reducer);

    const handleDeliveryTypeChange = (val) => {
        setDeliveryTypeVal(val)
        setShippingPrice(val === "regular" ? 0
            : val === "freeDelivery" ? 0
                : val === "twoDaysDelivery" ? 6.99
                    : val === "expressDelivery" ? 10.99
                        : 0)
    };





    useEffect(() => {
        setSubTotalVal(
            (cart.items.reduce((sum, product) => sum + parseFloat(product.quantity) * parseFloat(product.product.fPrice), 0) + parseFloat(shippingPrice) - parseFloat(discount)).toFixed(2) > 0 ?
                (cart.items.reduce((sum, product) => sum + parseFloat(product.quantity) * parseFloat(product.product.fPrice), 0) + parseFloat(shippingPrice) - parseFloat(discount)).toFixed(2) : 0
        )
    }, [shippingPrice, cart]);
    // useEffect(() => {

    //     setTaxEstimation(
    //         (subTotalVal * parseFloat(8.2) / (100)).toFixed(2) // need to be adjusted on the setting app value
    //     )
    //     setTotalPriceVal(parseFloat(parseFloat(subTotalVal) + parseFloat(taxEstimation)).toFixed(2))

    // }, [subTotalVal]);


    useEffect(() => {

        setTaxEstimation(
            (parseFloat(subTotalVal) * 0.082).toFixed(2) // need to be adjusted on the setting app value
        )
        setTotalPriceVal((parseFloat(subTotalVal) + (parseFloat(subTotalVal) * 0.082) + (parseFloat(tipping))).toFixed(2))

    }, [subTotalVal, tipping]);


    function deliveryDueDates(val) {

        const today = new Date();

        // Add days to today's date
        today.setDate(today.getDate() + val);

        // Format the date as a string (optional)
        const formattedDate = today.toLocaleDateString(); // e.g., "12/23/2024"
        return formattedDate

    }

    const handleTipping = (e) => {
        console.log("tipping", e.target.value)
        setTipping((parseFloat(e.target.value) * parseFloat(subTotalVal) * (0.01)).toFixed(2))
    }
    const handleTipsToggle = () => {
        setOpenTipsLink(!openTipsLink); // Toggles the state
    };

    tableContent_mod = (
        <>
            {
                cart.items.length === 0 ? <div>{EmptyCart}</div> :

                    <div className={`block lg:grid lg:grid-cols-12 mx-auto w-[90%] my-10`}>
                        <div className={`${(foodOrderType && !groceryOrderType) ? "md:col-span-9" : "md:col-span-6"}`}>
                            <h1 className="mb-4 text-center text-2xl font-bold">Order Summery</h1>

                            {tableContent_mod_}

                            {/* +++++++++++++++++++ */}
                            <div className="mx-auto w-3/4 justify-end px-2 md:flex md:space-x-4 xl:px-0 border-b-1 border-slate-200 .">

                                <button
                                    onClick={handleTipsToggle}
                                    class={`flex gap-1 my-4 align-middle font-semibold text-gray-900 dark:text-white`}>

                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>


                                    <p>
                                        Tips
                                    </p>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                                    </svg> */}
                                </button>

                                {openTipsLink ?
                                    <ul class=" items-center w-auto text-sm font-medium text-gray-900 grid grid-cols-3 gap-1 md:flex bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input
                                                    id="horizontal-list-radio-license"
                                                    type="radio"
                                                    value={0}
                                                    name="list-radio"
                                                    defaultChecked
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-license" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">0% </label>
                                            </div>
                                        </li>
                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input id="horizontal-list-radio-id"
                                                    type="radio"
                                                    value={5}
                                                    name="list-radio"
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-id" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">5%</label>
                                            </div>
                                        </li>
                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input id="horizontal-list-radio-military"
                                                    type="radio"
                                                    value={10}
                                                    name="list-radio"
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-military" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">10%</label>
                                            </div>
                                        </li>
                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input id="horizontal-list-radio-military"
                                                    type="radio"
                                                    value={15}
                                                    name="list-radio"
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-military" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">15%</label>
                                            </div>
                                        </li>

                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input id="horizontal-list-radio-military"
                                                    type="radio"
                                                    value={20}
                                                    name="list-radio"
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-military" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">20%</label>
                                            </div>
                                        </li>
                                        <li class="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
                                            <div class="flex items-center ps-3">
                                                <input id="horizontal-list-radio-military"
                                                    type="radio"
                                                    value={25}
                                                    name="list-radio"
                                                    onChange={(e) => { handleTipping(e); setCustomTip(true) }}
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label for="horizontal-list-radio-military" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">25%</label>
                                            </div>
                                        </li>
                                    </ul>
                                    : ''}


                            </div>
                            {/* ++++++++++++++++++ */}

                            {(foodOrderType) &&

                                <div class="flex items-center p-4 mb-4 text-sm text-red-600 rounded-xs bg-white dark:bg-gray-800 dark:text-red-600" role="alert">
                                    <svg class="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                                    </svg>

                                    <span class="sr-only">Info</span>
                                    <div className=' text-xs'>
                                        {(foodOrderType && groceryOrderType) && <>The cost of shipping estimate is for your <strong>grocery items only. </strong> </>}
                                        <div className=' mt-2'> We do not have a <strong>Food delivery driver </strong> available right now, you can pay online and pick up your order from the store.</div>
                                    </div>
                                </div>
                            }

                        </div>
                        {
                            groceryOrderType &&
                            <div className="lg:col-span-3 mx-4 ">
                                <div className=" my-4">Shipping estimate</div>
                                <div className="flex items-center my-4">
                                    <input
                                        id="regular"
                                        type="radio"
                                        name="deliveryType"
                                        value="regular"
                                        onChange={() => handleDeliveryTypeChange("regular")}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"

                                    />

                                    <label htmlFor="regular"
                                        className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        <p>Fast, Free Delivery</p>
                                        <p>{
                                            deliveryDueDates(7)
                                        }</p>
                                    </label>
                                </div>
                                <div className="flex items-center">
                                    <input
                                        id="twoDaysDelivery"
                                        type="radio"
                                        name="deliveryType"
                                        value="twoDaysDelivery"
                                        onChange={() => handleDeliveryTypeChange("twoDaysDelivery")}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                    <label
                                        htmlFor="twoDaysDelivery"
                                        className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        {/* <p>Wednesday, Dec 18 and Thursday, Dec 19</p> */}
                                        <p>{
                                            deliveryDueDates(3)
                                        }</p>
                                        <p>$6.99 - Delivery</p>
                                    </label>
                                </div>
                                <div className="flex items-center my-4">
                                    <input
                                        id="expressDelivery"
                                        type="radio"
                                        name="deliveryType"
                                        value="expressDelivery"
                                        onChange={() => handleDeliveryTypeChange("expressDelivery")}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                    <label
                                        htmlFor="expressDelivery"
                                        className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        <p>{
                                            deliveryDueDates(2)
                                        }</p>
                                        <p>$10.99 - Delivery</p>
                                    </label>
                                </div>
                                <div className="flex items-center">
                                    <input
                                        id="freeDelivery"
                                        type="radio"
                                        name="deliveryType"
                                        value="freeDelivery"
                                        onChange={() => handleDeliveryTypeChange("freeDelivery")}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                    <label htmlFor="freeDelivery"
                                        className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                        <p>{
                                            deliveryDueDates(10)
                                        }</p>
                                        <p>FREE Delivery</p>
                                    </label>
                                </div>
                                <div className='flex items-center mt-4'>
                                    <div className="block">
                                        <p className="text-gray-700"> Do you have a voucher or gift card?</p>
                                        <div className="text-gray-700 flex justify-between items-center ">
                                            <input
                                                className={`appearance-none text-sm my-1 flex h-[25px] md:w-3/4 bg-gray-200 text-gray-700 border border-gray-400 rounded py-1 px-2 mb-1 leading-tight focus:outline-none focus:bg-white`}
                                                id="discount"
                                                name="discount"
                                                type="text"
                                                autoComplete="off"
                                                value={discount}
                                                onChange={onDiscountChanged}
                                            />
                                            <button className="bg-transparent text-sm hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-0 px-3 border border-blue-500 hover:border-transparent rounded-sm h-[25px]">
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }

                        <div className="lg:col-span-3" >
                            {/* <!-- Sub total --> */}
                            <div className="mt-10 h-auto rounded-sm border bg-white p-6 shadow-md lg:mt-0 w-full">
                                <h1 className="mb-4 text-center text-2xl font-bold">Shopping Cart</h1>
                                <div className="mb-2 flex justify-between">
                                    <p className="text-gray-700">Subtotal</p>
                                    <p className="text-gray-700">$
                                        {
                                            subTotalVal}</p>
                                </div>
                                <div className="mb-2 flex justify-between">
                                    <p className="text-gray-700">Shipping Price</p>
                                    <p className="text-gray-700">$
                                        {
                                            shippingPrice}</p>
                                </div>
                                           
                                <div className="mb-2 flex justify-between">
                                    <p className="text-gray-700">Tax estimate</p>
                                    <p className="text-gray-700">$
                                        {
                                            taxEstimation
                                        }
                                    </p>
                                </div>
                                 <div className="mb-2 flex justify-between">
                                    <p className="text-gray-700">Your Tips</p>
                                    <p className="text-gray-700">$
                                        {
                                            tipping
                                        }
                                    </p>
                                </div>
                                        
                                        
                                <hr className="my-4" />
                                <div className="flex justify-between">
                                    <p className="text-lg font-bold">Total</p>
                                    <div className="">
                                        <p className="mb-1 text-lg font-bold">

                                            ${' '}
                                            {
                                                totalPriceVal
                                            }

                                        </p>
                                        {/* <p className="text-sm text-gray-700">including VAT</p> */}
                                    </div>
                                </div>
                                <button type="button" className=" mt-6 py-1.5 text-white gap-2 bg-[#050708] hover:bg-[#050708]/90 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-xs w-full text-sm px-5 text-center inline-flex items-center dark:focus:ring-[#050708]/50 dark:hover:bg-[#050708]/30 me-2 mb-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
                                    </svg>
                                    <Link to="/OnlineOrdering/checkOut" state={{ totalPriceVal, deliveryTypeVal, subTotalVal, shippingPrice, taxEstimation, foodOrderType, groceryOrderType, tipping }}>
                                        Proceed to Checkout
                                    </Link>
                                </button>
                                <Link to={"/OnlineOrdering"}>
                                    <button type="button" className=" mt-6 py-1.5 text-black gap-2 bg-[#cfd2d3] hover:bg-[#dde0e1] focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-xs w-full text-sm px-5 text-center inline-flex items-center dark:focus:ring-[#050708]/50 dark:hover:bg-[#050708]/30 me-2 mb-2">
                                        Continue Shopping
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 align-middle text-center">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                                        </svg>
                                    </button>
                                </Link>

                            </div>
                        </div>
                    </div>
            }
        </>
    )

    return tableContent_mod
}

export default NewOrder
